module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA+klEQVRIS+2W3REBQRCE+4uAEGSACBABMiASREIGiMDJ4GQgBBfBqLk6VQ57f3hiqu7ltmd7t3dnelFBmFksqVuEkRQD/RCGEoKLpFYJQQK0mxJ0JPlXFGfgHCQws0kFGUo4gsMnzMyaZlfJcwLfQS8DDyUNqiQWYI6Somw8zh2ymS0lLd4kWAE+Txq/QXAEhg/ypTIECrG2RLfJ/AIcMmlHQBQ4sz9BKtJfolwtf/0WRcDom3VQtzXVroOPEswkrevO+ICfA5tQN3Vvdfsr8+HQGhK3WMC9/Lld+5/MgLYNdzEFdve5L18VZuYO56Yxrki0dzzgz5xcXAG7btOv+ev3jgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/delete.png
// module id = qZET
// module chunks = 96